import { FC, MouseEvent, useState } from 'react';
import styled from 'styled-components';

import Button from '@/components/Button';
import Checkbox from '@/components/Checkbox';
import { Input, Textarea } from '@/components/Forms';
import ShowHideButton from '@/components/ShowHideButton';
import Text from '@/components/Text';

import {
  Box,
  ButtonHolder,
  Header,
  HeaderButtons,
  Heading,
  LabelText,
  ResetButton,
} from '../VariationOne';
import { ImageGrid, TextAreaBox } from '../VariationTwo';
import { Filler } from '../shared';
import { ActionBox, ActionTitle } from '../shared/styledComponents';
import GeneratedImages from './GeneratedImages';

export interface ImageVariation {
  heading: string;
  text: string;
  brakes: boolean;
  fontSize?: number;
}

const StyledTextArea = styled(Textarea)`
  height: 108px;
`;

const StyledImageGrid = styled(ImageGrid)`
  grid-template-columns: 1fr;
`;
const HeadingTextArea = styled(Textarea)`
  height: 60px;
`;

interface Props {
  inArticle?: boolean;
}

const VariationYouOneOuOne: FC<Props> = ({ inArticle }) => {
  const [showContent, setShowContent] = useState(true);
  const [text, setText] = useState('');
  const [heading, setHeading] = useState('');
  const [brakes, setBrakes] = useState(false);
  const [fontSize, setFontSize] = useState('');
  const [variations, setVariations] = useState<ImageVariation[]>([]);
  const [images, setImages] = useState<string[]>();

  const onReset = () => {
    setVariations([]);
    setImages([]);
    setText('');
    setBrakes(false);
    setFontSize('');
  };

  const generateVariations = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    const newVariations = () => [
      {
        heading: heading,
        text: text,
        brakes: brakes,
        fontSize: parseInt(fontSize),
      },
    ];

    setVariations(newVariations);
  };

  const isResetDisabled = !text && !brakes && !fontSize;

  return (
    <>
      <Filler fontFamily="Gothic" />
      <Box>
        <Header>
          <div>
            <Heading $type="button">You 101</Heading>
            <Text $type="smallHeadline" $color="gray">
              Attach heading and add text with the necessary parameters
            </Text>
          </div>
          <HeaderButtons>
            <ResetButton
              color="red"
              disabled={isResetDisabled}
              onClick={onReset}
            >
              Reset
            </ResetButton>
            <ShowHideButton
              showContent={showContent}
              onClick={() => setShowContent((prev) => !prev)}
            />
          </HeaderButtons>
        </Header>
        {showContent && (
          <StyledImageGrid>
            <div>
              <TextAreaBox>
                <div>
                  <LabelText $type="smallHeadline">Heading</LabelText>
                  <HeadingTextArea
                    onChange={(e) => setHeading(e.target.value)}
                    value={heading}
                    placeholder="Add text"
                  ></HeadingTextArea>
                </div>
                <div>
                  <LabelText $type="smallHeadline">Text</LabelText>
                  <StyledTextArea
                    onChange={(e) => setText(e.target.value)}
                    value={text}
                    placeholder="Add text"
                  ></StyledTextArea>
                </div>
                <div>
                  <LabelText $type="smallHeadline">Font Size</LabelText>
                  <Input
                    value={fontSize}
                    onChange={(e) => setFontSize(e.target.value)}
                    placeholder="Font Size (px)"
                    type="number"
                    min="0"
                  />
                </div>
                <div>
                  <ActionTitle $type="smallHeadline">
                    Text Parameters
                  </ActionTitle>
                  <ActionBox>
                    <Checkbox
                      checked={brakes}
                      onChange={() => setBrakes((prev) => !prev)}
                    >
                      Custom brakes
                    </Checkbox>
                  </ActionBox>
                </div>
              </TextAreaBox>
            </div>
          </StyledImageGrid>
        )}
      </Box>
      {showContent && (
        <ButtonHolder>
          <Button onClick={generateVariations}>
            {!!variations?.length ? 'Regenerate' : 'Generate'}
          </Button>
        </ButtonHolder>
      )}
      <GeneratedImages
        variations={variations}
        images={images}
        setImages={setImages}
        inArticle={inArticle}
        onReset={onReset}
      />
    </>
  );
};

export default VariationYouOneOuOne;
